import React from 'react'
import { Spinner } from 'reactstrap'

const FormLoader = ({size="sm"}) => {
  return  <Spinner  
  as="span"
  animation="border"
  size={size}
  role="status"
  aria-hidden="true"
  />;
}

export default FormLoader